<template>
  <div class="uppgifter2">
    <div class="back-nav">
      <router-link :to="{ name: 'uppgifter' }" class="back-nav__link back-button"><Arrow /> Tillbaka</router-link>
    </div>
    <h1 class="uppgifter2__title"><b>Mina uppgifter</b> 2/2</h1>
    <form @submit.prevent="lookup" class="uppgifter2__lookup">
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label uppgifter2__field-label--title">Personnummer</span>
          <input type="text" v-model="$root.personnummer" placeholder="ååååmmdd-xxxx" class="uppgifter2__field">
        </label>
        <button type="submit" class="uppgifter2__lookup-submit button button--secondary">Hämta adress automatiskt</button>
    </form>
    <form @submit.prevent="submit">
      <h2 class="uppgifter2__block-title">Fyll i dina personuppgifter</h2>
      <div class="uppgifter2__field-group">
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label">Förnamn <em>*</em></span>
          <input type="text" v-model="$root.name" class="uppgifter2__field" required>
        </label>
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label">Efternamn <em>*</em></span>
          <input type="text" v-model="$root.surname" class="uppgifter2__field" required>
        </label>
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label">Adress <em>*</em></span>
          <input type="text" v-model="$root.address" class="uppgifter2__field" required>
        </label>
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label">Postnummer <em>*</em></span>
          <input type="text" v-model="$root.postal_code" class="uppgifter2__field" required>
        </label>
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label">Ort <em>*</em></span>
          <input type="text" v-model="$root.location" class="uppgifter2__field" required>
        </label>
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label">Telefon <em>*</em></span>
          <input type="text" v-model="$root.phone" class="uppgifter2__field" required>
        </label>
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label">E-postadress <em>*</em></span>
          <input type="email" v-model="$root.email" class="uppgifter2__field" required>
        </label>
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label">Bekräfta e-postadress <em>*</em></span>
          <input type="email" v-model="$root.email_confirm" class="uppgifter2__field" required>
        </label>
      </div>
      <div class="uppgifter2__other-location">
        <label class="checkbox">
          <input type="checkbox" class="checkbox__field" v-model="$root.another_address">
          <span class="checkbox__label">Jag vill ha elen till en annan adress än ovan (ex. sommarstuga)</span>
        </label>
        <div class="uppgifter2__field-group" v-if="$root.another_address">
          <label class="uppgifter2__field-wrapper">
            <span class="uppgifter2__field-label">Adress <em>*</em></span>
              <input type="text" v-model="$root.other_address" class="uppgifter2__field" required>
          </label>
            <label class="uppgifter2__field-wrapper">
            <span class="uppgifter2__field-label">Postnummer <em>*</em></span>
              <input type="text" v-model="$root.other_postal_code" class="uppgifter2__field" required>
          </label>
            <label class="uppgifter2__field-wrapper">
            <span class="uppgifter2__field-label">Ort <em>*</em></span>
              <input type="text" v-model="$root.other_location" class="uppgifter2__field" required>
          </label>
        </div>
      </div>
      <div class="uppgifter2__ids">
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label uppgifter2__field-label--title">Anläggnings-id</span>
          <input type="text" v-model="$root.construction_id" placeholder="Ex: 735 999 XXX XXX XXX XXX" class="uppgifter2__field">
        </label>
        <label class="uppgifter2__field-wrapper">
          <span class="uppgifter2__field-label uppgifter2__field-label--title">Områdes-ID</span>
          <input type="text" v-model="$root.territory_id" placeholder="Ditt områdes-ID" class="uppgifter2__field">
        </label>
        <p class="uppgifter2__ids-text">Du hittar dessa uppgifter på fakturan ifrån ditt elnätsbolag.</p>
      </div>
      <label class="checkbox">
        <input type="checkbox" class="checkbox__field" v-model="$root.acknowledgement" required>
        <span class="checkbox__label">Härmed lämnar jag fullmakt till Borås Elhandel att i mitt ställe inhämta uppgifter från mitt nuvarande elnätsföretag, om min elanläggning och uppgifter om registrerat elhandelsföretag; samt uppsägningstid och bindningstid avseende nuvarande elavtal och ger dem rätten att säga upp detta elavtal.</span>
      </label>
      <div class="step-nav">
        <!--<router-link :to="{ name: 'uppgifter' }" class="step-nav__link back-button"><Arrow /> Mina uppgifter 1 / 2</router-link>-->
        <button type="submit" class="button button--with-icon step-nav__button">Fortsätt för att slutföra <Arrow /></button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  methods: {
    submit() {
      this.$router.push({ name: 'bekrafta' })
    },
    lookup() {
      fetch('https://randomuser.me/api/?nat=ch,de,dk,fi,no&noinfo').then(r => r.json()).then(r => {
        this.$root.name = r.results[0].name.first;
        this.$root.surname = r.results[0].name.last;
        this.$root.address = r.results[0].location.street.name + ' ' + r.results[0].location.street.number;
        this.$root.location = r.results[0].location.city;
        this.$root.postal_code = r.results[0].location.postcode;
        this.$root.email = r.results[0].email;
        this.$root.email_confirm = r.results[0].email;
        this.$root.phone = r.results[0].phone;
      });
    },
  }
}
</script>
<style lang="scss">
  .uppgifter2 {
    &__title {
      text-align: center;
      margin: 0 0 rem(30);
      @include font-primary;
      @include media('>lg') {
        font-size: rem(26);
      }
      @include media('<=lg') {
        font-size: rem(22);
        line-height: (36/22);
      }
    }
    &__block {
      margin-bottom: rem(40);
    }
    &__block-title {
      @include font-primary(bold);
      color: $secondary-text-color;
      font-size: rem(18);
      margin: 0 0 rem(15);
    }
    &__field-wrapper {
      margin-bottom: rem(24);
      font-size: rem(16);
      display: block;
    }
    &__field-group {
      @include media('>lg') {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-end;
      }
    }
    &__lookup {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-end;
    }
    &__field-group &__field-wrapper {
      @include media('>lg') {
        flex-basis: calc(50% - #{rem(12)});
      }
    }
    &__lookup &__field-wrapper {
      flex-basis: calc(50% - #{rem(12)});
    }
    &__field {
      @include unstyled-text-field;
      display: block;
      width: 100%;
      border: 1px solid $light-border-color;
      padding: #{(13/18)}em;
      &:focus,
      &:hover {
        border-color: $dark-border-color;
      }
      &::placeholder {
        color: $dark-border-color;
      }
    }
    &__field-label {
      @include font-primary;
      color: $secondary-text-color;
      margin: 0 0 rem(6);
      display: block;
      &--title {
        @include font-primary(bold);
        color: $secondary-text-color;
        font-size: rem(18);
        display: block;
        margin: 0 0 rem(9);
      }
      em {
        font-style: normal;
        color: #c00;
      }
    }
    &__lookup-submit {
      flex: 1 1;
      margin: 0 0 rem(24) rem(24);
      font-size: rem(16);
    }
    &__ids {
      margin-bottom: 1rem;
    }
    &__ids-text {
      @include font-primary(roman);
      font-size: rem(13);
      padding: rem(16);
      background-color: $light-bg-color;
      color: $secondary-text-color;
      text-align: center;
      border-radius: 4px;
    }
  }
</style>